import { useEffect, useState } from 'react'

const useAnnotationFilters = () => {
  const [authoredByExpanded, setAuthoredByExpanded] = useState(false)
  const [visibilityExpanded, setVisibilityExpanded] = useState(false)
  const [archiveExpanded, setArchiveExpanded] = useState(false)
  const [previewExpanded, setPreviewExpanded] = useState(false)

  useEffect(() => {
    if (authoredByExpanded) {
      setVisibilityExpanded(false)
      setArchiveExpanded(false)
      setPreviewExpanded(false)
    }
  }, [authoredByExpanded])

  useEffect(() => {
    if (visibilityExpanded) {
      setAuthoredByExpanded(false)
      setArchiveExpanded(false)
      setPreviewExpanded(false)
    }
  }, [visibilityExpanded])

  useEffect(() => {
    if (archiveExpanded) {
      setAuthoredByExpanded(false)
      setVisibilityExpanded(false)
      setPreviewExpanded(false)
    }
  }, [archiveExpanded])

  useEffect(() => {
    if (previewExpanded) {
      setAuthoredByExpanded(false)
      setVisibilityExpanded(false)
      setArchiveExpanded(false)
    }
  }, [previewExpanded])

  return {
    authoredByExpanded,
    setAuthoredByExpanded,
    visibilityExpanded,
    setVisibilityExpanded,
    archiveExpanded,
    setArchiveExpanded,
    previewExpanded,
    setPreviewExpanded
  }
}

export default useAnnotationFilters
